import axios from "axios";

export default {
  campuses() {
    return axios.get("/api/campuses");
  },
  allCampuses() {
    return axios.get("/api/all_campuses");
  },
  schools() {
    return axios.get("/api/schools");
  },
  showSchool(slug) {
    return axios.get("/api/school/" + slug);
  },
  showCampus(slug) {
    return axios.get("/api/campus/" + slug);
  },
  schoolEvents(slug) {
    return axios.get("/api/school/" + slug + "/events");
  },
  schoolTrainings(slug) {
    return axios.get("/api/school/" + slug + "/trainings");
  },
  schoolTrainingsList(slug) {
    return axios.get("/api/school/" + slug + "/trainings_list");
  },
  schoolTrainingsThemeList(slug) {
    return axios.get("/api/school/" + slug + "/trainings_theme_list");
  },
  addSchool(data) {
    return axios.post("/api/organization/school/add", data);
  },
  editSchool(data) {
    return axios.post("/api/organization/school/edit/" + data.id, data);
  },
  archiveSchool(data) {
    return axios.post("/api/organization/school/archive", data);
  },
  addSchoolDocument(data) {
    return axios.post("/api/organization/school/add/document", data);
  },
  delSchoolDocument(data) {
    return axios.post("/api/organization/school/del/document", data);
  },
  addCampus(data) {
    return axios.post("/api/organization/campus/add", data);
  },
  editCampus(data) {
    return axios.post("/api/organization/campus/edit/" + data.id, data);
  },
  archiveCampus(data) {
    return axios.post("/api/organization/campus/archive", data);
  },
  restoreCampus(data) {
    return axios.post("/api/organization/campus/restore", data);
  },

  themes() {
    return axios.get("/api/themes");
  },
  deleteTheme(data) {
    return axios.post("/api/organization/theme/delete", data);
  },
  deleteSection(data) {
    return axios.post("/api/organization/section/delete", data);
  },

  trainings(query) {
    return axios.get("/api/trainings", {
      params: {
        per_page: query.perPage,
        page: query.page,
        school: query.school,
        search: query.search,
        archived: query.archived
      }
    });
  },
  trainingsList(query) {
    return axios.get("/api/trainings_list", {
      params: {
        per_page: query.perPage,
        page: query.page,
        school: query.school,
        search: query.search,
        archived: query.archived
      }
    });
  },
  training(id) {
    return axios.get("/api/training/show/" + id);
  },
  exportTrainings() {
    return axios
        .get('/api/organization/trainings/export', {
          responseType: 'blob'
        })
        .then(function (response) {
          return response;
        });
  },
  trainingFees(id, query) {
    return axios
      .get("/api/training/fees/" + id, query)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  addTraining(data) {
    return axios
      .post("/api/organization/training/add", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  importTrainingDates (file) {
    return axios
        .post('/api/organization/training/dates/import', file)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  importTrainingCapacities (file) {
    return axios
        .post('/api/organization/training/capacities/import', file)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  editTraining(data) {
    return axios.post("/api/organization/training/edit/" + data.id, data);
  },
  archiveTraining(data) {
    return axios.post("/api/organization/training/archive", data);
  },
  deleteTrainingOption(data) {
    return axios.post("/api/organization/trainingoption/delete", data);
  },
  addRegistrationFee(data) {
    return axios.post("/api/organization/fees/add", data);
  },
  addTrainingDates(data) {
    return axios.post("/api/organization/training/dates/add", data);
  },
  addTrainingCapacities(data) {
    return axios.post('/api/organization/training/capacities/add', data);
  },
  page(id) {
    return axios.get("/api/page/show/" + id);
  },
  editPage(data) {
    return axios.post("/api/page/edit/" + data.id, data);
  },

  settings() {
    return axios.get("/api/settings");
  },
  setting(key) {
    return axios.get("/api/setting/show/" + key);
  },
  scholarYears() {
    return axios.get("/api/settings/scholar_years");
  },
  editSettings(data) {
    return axios.post("/api/settings/update", data);
  },
  trainingStats(query) {
    return axios.get("/api/training/stats", {
      params: {
        step: query.filter,
        year: query.year,
        begin: query.begin,
        end: query.end
      }
    });
  },
  exportTrainingStats(query) {
    return axios.get("/api/training/stats/export", {
      responseType: "blob",
      params: {
        step: query.filter,
        year: query.year,
        begin: query.begin,
        end: query.end
      }
    });
  },
  documents() {
    return axios.get("/api/documents");
  },
  document(id) {
    return axios.get("/api/document/" + id);
  },
  addDocument(data) {
    return axios.post("/api/documents/add", data);
  },
  editDocument(data) {
    return axios.post("/api/documents/update", data);
  },
  deleteDocument(data) {
    return axios.post("/api/documents/delete", data);
  }
};
